import { useFormikContext } from "formik";
import React, { FC, ReactElement, useState } from "react";
import { FILTER_BUILDINGS, FILTER_DEVICE_TYPE, FILTER_DOORS, FILTER_SITES, FILTER_ZONES } from "../../../constants/notification-key";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { SettingData } from "../../../models/SettingData";
import { handleManage } from "../../../services/notificationService";
import ActivityFrame from "../../activity-frame/activity-frame";
import { toast } from "react-toastify";
import FilterByBuilding from "./filter-by/filter-by-building";
import FilterByDevice from "./filter-by/filter-by-device";
import FilterByDoor from "./filter-by/filter-by-doors";
import FilterBySite from "./filter-by/filter-by-site";
import FilterByZone from "./filter-by/filter-by-zone";

interface EventBasedDetailsProps {
    reloadPage: () => void;
}

const EventBasedDetails: FC<EventBasedDetailsProps> = ({ reloadPage }) => {
    const [busy, setBusy] = useState(false);
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();

    const getContent = (filterBy: string): ReactElement => {
        if (filterBy === FILTER_SITES.eSysnameLookup) {
            return <FilterBySite manageItems={manageItems}/>
        }
        else if (filterBy === FILTER_DOORS.eSysnameLookup) {
            return <FilterByDoor manageItems={manageItems} />
        }
        else if (filterBy === FILTER_BUILDINGS.eSysnameLookup) {
            return <FilterByBuilding manageItems={manageItems} />
        }
        else if (filterBy === FILTER_ZONES.eSysnameLookup) {
            return <FilterByZone manageItems={manageItems} />
        }
        else if (filterBy === FILTER_DEVICE_TYPE.eSysnameLookup) {
            return <FilterByDevice manageItems={manageItems} />
        }

        return <></>;
    }

    const buildSettingDataToAdd = (toBeAdded: string[]): SettingData[] => {
        const settingDataToAdd: SettingData[] = toBeAdded.map((id) => ({
            sdValstring: id,
            eSysnameLookup: values.filterBy,
            relationship: [
                {
                    id: values.vruleFilterIds,
                    type: "ruleTriggerGroup",
                    relationType: "vruleTriggerGroup"
                },
                {
                    id: id,
                    type: values.relationType
                }
            ]

        }))

        return settingDataToAdd;
    }

    const getSettingDataIdsToDelete = (toBeRemoved: string[]): string[] => {
        let settingDataToRemove: string[] = [];

        if (toBeRemoved.length > 0) {
            const filteredOutSettingData = values.settingDatasRef.filter((ref) => ref.elementSysname === values.filterBy && toBeRemoved.includes(ref.sdValstring));
            filteredOutSettingData.map((remove) => {
                settingDataToRemove.push(remove.id)
            })
        }

        return settingDataToRemove;
    }

    const manageItems = async (selectedIds: string[], oldSelectedIds: string[]) => {
        setBusy(true);
        const newSelectedIds = selectedIds.filter((value) => value !== "");

        if (newSelectedIds.length < 1) {
            toast.error(translate.byKey(TranslationKeys.atLeastOneOptionNeedsToBeSelected));
            setBusy(false);
            return;
        }

        const toBeRemoved: string[] = oldSelectedIds.filter((value) => {
            if (!newSelectedIds.includes(value)) {
                return value
            }
        });

        const toBeAdded: string[] = newSelectedIds.filter((value) => {
            if (!oldSelectedIds.includes(value)) {
                return value;
            }
        });

        const dataToAdd = buildSettingDataToAdd(toBeAdded);
        const dataToRemove = getSettingDataIdsToDelete(toBeRemoved);

        handleManage(dataToAdd, dataToRemove).then((response: any) => {
            toast.success(translate.byKey(TranslationKeys.success));
            setFieldValue("filterIds", newSelectedIds);
            reloadPage();
        }).catch((message) => {
            toast.error(message);
        }).finally(() => {
            setBusy(false);
        })
    }

    return (
        <ActivityFrame busy={busy} className='flex flex-col flex-grow bg-white'>
            {getContent(values.filterBy)}
        </ActivityFrame>
    )
}

export default EventBasedDetails;
